import React from "react";
import { Helmet } from "react-helmet-async";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>İletişim | Psikolog Yağmur Demiröz</title>
        <meta 
          name="description" 
          content="Psikolog Yağmur Demiröz ile randevu almak ve bilgi almak için iletişim bilgilerini inceleyin. Telefon, e-posta ve ofis adresi detayları burada." 
        />
        <meta name="robots" content="index, follow" />
        
        {/* Open Graph / Facebook / WhatsApp */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yagmurdemiroz.com/iletisim" />
        <meta property="og:title" content="İletişim - Psikolog Yağmur Demiröz" />
        <meta property="og:description" content="Randevu ve bilgi için iletişim: +90 544 135 47 54 | pskyagmurdemiroz@gmail.com | Nispetiye/Etiler, İstanbul" />
        <meta property="og:image" content="https://yagmurdemiroz.com/me.jpg" />
        <meta property="og:locale" content="tr_TR" />
        <meta property="og:site_name" content="Yağmur Demiröz - Psikolog" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:url" content="https://yagmurdemiroz.com/iletisim" />
        <meta name="twitter:title" content="İletişim - Psikolog Yağmur Demiröz" />
        <meta name="twitter:description" content="Randevu ve bilgi için iletişim bilgileri." />
        <meta name="twitter:image" content="https://yagmurdemiroz.com/logo.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "Psikolog Yağmur Demiröz",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Nispetiye / Etiler",
              "addressLocality": "İstanbul",
              "addressCountry": "TR"
            },
            "telephone": "+90 544 135 47 54",
            "email": "pskyagmurdemiroz@gmail.com",
            "openingHours": "Mo-Fr 09:00-18:00",
            "url": "https://yagmurdemiroz.com/iletisim",
            "sameAs": [
              "https://www.instagram.com/psk.yagmurdemiroz",
              "https://www.linkedin.com/in/yagmurdemiroz"
            ]
          })}
        </script>
      </Helmet>

      <div className="container mx-auto px-4 py-8">
        <header className="text-center mb-8">
          <div className="animate-fadeIn">
            <h1 className="text-4xl font-bold text-secondary">İletişime Geçin</h1>
            <p className="text-lg text-gray-700 mt-2">
              Randevu almak veya detaylı bilgi edinmek için aşağıdaki iletişim bilgilerini kullanabilirsiniz.
            </p>
          </div>
        </header>

        {/* Email Section */}
        <div 
          className="mb-8 flex items-center text-lg text-gray-700"
          style={{
            animation: 'fadeInLeft 0.5s ease-in-out forwards',
            opacity: 0,
            animationDelay: '0.2s'
          }}
        >
          <FaEnvelope className="mr-2 text-secondary text-xl" />
          <a
            href="mailto:pskyagmurdemiroz@gmail.com"
            className="hover:underline"
          >
            pskyagmurdemiroz@gmail.com
          </a>
        </div>

        {/* Two Location Cards Side by Side */}
        <div className="grid md:grid-cols-2 gap-6">
          {/* Nispetiye/Etiler */}
          <div 
            className="bg-white border-2 border-secondary rounded-lg overflow-hidden shadow-lg"
            style={{
              animation: 'fadeInLeft 0.5s ease-in-out forwards',
              opacity: 0,
              animationDelay: '0.4s'
            }}
          >
            <div className="bg-secondary text-label p-4">
              <h2 className="text-xl font-bold">Nispetiye / Etiler</h2>
            </div>
            <div className="p-4 space-y-3">
              <div className="flex items-start">
                <FaPhoneAlt className="mr-2 text-secondary mt-1 flex-shrink-0" />
                <a href="tel:+905441354754" className="hover:underline text-gray-800">
                  +90 544 135 47 54
                </a>
              </div>
              <div className="flex items-start">
                <FaMapMarkerAlt className="mr-2 text-secondary mt-1 flex-shrink-0" />
                <a href="https://maps.app.goo.gl/sL9XxCRfdvr5y17P7" target="_blank" rel="noreferrer" className="hover:underline text-gray-800">
                  Nispetiye / Etiler, İstanbul
                </a>
              </div>
              <div className="mt-4 pt-4 border-t border-gray-200">
                <iframe
                  title="Nispetiye/Etiler Ofis Konumu"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d529.5050629137671!2d29.019290307728955!3d41.075501341966074!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1str!2str!4v1728923209162!5m2!1str!2str"
                  className="rounded-md w-full h-[300px]"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>

          {/* Ümraniye */}
          <div 
            className="bg-white border-2 border-secondary rounded-lg overflow-hidden shadow-lg"
            style={{
              animation: 'fadeInRight 0.5s ease-in-out forwards',
              opacity: 0,
              animationDelay: '0.6s'
            }}
          >
            <div className="bg-secondary text-label p-4">
              <h2 className="text-xl font-bold">Ümraniye</h2>
            </div>
            <div className="p-4 space-y-3">
              <div className="flex items-start">
                <FaPhoneAlt className="mr-2 text-secondary mt-1 flex-shrink-0" />
                <a href="tel:+905380792109" className="hover:underline text-gray-800">
                  +90 538 079 21 09
                </a>
              </div>
              <div className="flex items-start">
                <FaMapMarkerAlt className="mr-2 text-secondary mt-1 flex-shrink-0" />
                <span className="text-gray-800">Ümraniye, İstanbul</span>
              </div>
              <div className="mt-4 pt-4 border-t border-gray-200">
                <div className="w-full h-[300px] bg-gray-100 rounded-md flex items-center justify-center">
                  <p className="text-gray-600 text-center">Harita konumu yakında eklenecek</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div 
          className="text-center mt-10"
          style={{
            animation: 'fadeInUp 0.5s ease-in-out forwards',
            opacity: 0,
            animationDelay: '1s'
          }}
        >
          <p className="text-gray-700">
            Daha fazla bilgi almak için <a href="/hakkimda" className="text-secondary hover:underline">Hakkımda</a> sayfasına göz atabilirsiniz.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;